// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"style__loadingWrapper__AWT32","reportWrapper":"style__reportWrapper__o6JED"};